<template>
  <cube-sticky ref="sticky" :pos="scrollY" :check-top="checkTop">
    <div class="scroll-ele" @scroll="scrollHandler">
      <div class="newtitlebox" v-show="!lcsmyos">
        <div class="titlebox">
          <p>
            查社保、查公积金，预约挂号、生活
            缴费、12345政府热线等尽在龙城市民云APP
          </p>
        </div>
        <div class="btnbox">
          <a href="javascript:void(0)" @click="toDownapp">立即下载</a>
        </div>
      </div>
      <div id="news-main" v-if="showData">
        <h3 id="data-title" v-html="newsDatails.title"></h3>
        <div id="data-time">
          <span class="time">{{ newsDatails.time }}</span>
          <!-- 评论上线后放开  start-->
          <!-- <div class="comment-numbox" v-if="lcsmyos">
            <icon-svg icon-class="comment_num" className="icon"></icon-svg>
            <span class="comment-num">{{ discussCount }}</span>
          </div> -->
          <!-- 评论上线后放开  end-->
        </div>
        <div
          id="data-body"
          @click="previewImg($event)"
          v-html="newsDatails.content"
        ></div>
        <div
          class="data-file"
          v-if="newsDatails.fileManagers && newsDatails.fileManagers.length > 0"
        >
          <p class="filetitle">相关资料下载</p>
          <div v-for="(item, index) in newsDatails.fileManagers" :key="index">
            <p class="filename">{{ `${item.name}` }}</p>
            <p class="filedown">
              <a class="abtn1" :href="imgbaseurl + item.fastdfsUrl">立即下载</a>
            </p>
          </div>
        </div>
      </div>
      <nodata :nodata="nodata" :msg="'暂无数据~'"></nodata>
      <!-- 评论上线后放开  start-->
      <div class="gap" v-if="discussList.length"></div>
      <div v-if="newsDatails.commentSwitch == 1">
        <cube-sticky-ele v-if="lcsmyos && showData">
          <div class="input-box">
            <div class="comment-num">用户评论（{{ discussCount }}）</div>
            <div class="my-input" @click="toDiscuss(1, { textUser: '写留言' })">
              <icon-svg
                icon-class="writing"
                className="writing-icon"
              ></icon-svg>
              <span class="text">我也说两句...</span>
            </div>
          </div>
        </cube-sticky-ele>
        <div
          class="no-comment"
          v-if="lcsmyos && showData && !discussList.length"
        >
          暂无留言，快去留言吧~
        </div>
      </div>
      <ul class="comment-box" v-if="discussList.length">
        <li class="comment-list" v-for="(discuss, i) in discussList" :key="i">
          <div
            class="icon"
            :style="{ backgroundImage: `url(${imgBase + discuss.avatar})` }"
          ></div>
          <div class="list-right">
            <div class="author">{{ discuss.userName | filterUserName }}</div>
            <div class="comment-text">{{ discuss.content }}</div>
            <div class="toolbox">
              <div class="tool-left">
                <div class="time">{{ discuss.createTime }}</div>
                <div
                  class="delete"
                  v-if="lcsmyos && isLogined && discuss.isRemove === '1'"
                  @click="deleteDiscuss(discuss.id, discuss.isRemove)"
                >
                  删除
                </div>
              </div>
              <div
                class="tool-right"
                v-if="lcsmyos && isLogined"
                @click="toDiscuss(2, discuss)"
              >
                回复
              </div>
            </div>
            <ul class="answer-box" v-if="discuss.commentReplyList.length">
              <li
                class="answer-list"
                v-for="(reply, j) in calcReplyList(
                  seeMoreIndex == i,
                  discuss.commentReplyList
                )"
                :key="`reply_` + j"
              >
                <div class="content">
                  <span class="answer-name"
                    >{{ reply.userName | filterUserName }}：</span
                  >
                  <span class="answer-content">{{ reply.replyContent }}</span>
                </div>
                <div class="answer-tool">
                  <div class="time">{{ reply.createTime }}</div>
                  <div
                    class="delete"
                    v-if="lcsmyos && isLogined && reply.isRemove === '1'"
                    @click="deleteReply(reply.id, reply.isRemove)"
                  >
                    删除
                  </div>
                </div>
              </li>
              <div
                class="see-more"
                v-if="discuss.commentReplyList.length > 3 && seeMoreIndex != i"
                @click="seeMore(i)"
              >
                <span>查看全部留言</span>
                <icon-svg icon-class="blue_arrow" className="arrow" />
              </div>
            </ul>
          </div>
        </li>
      </ul>
      <div class="discuss" v-show="showDiscuss">
        <div class="top-box">
          <div class="title" v-if="textUser == '写留言'">{{ textUser }}</div>
          <div class="title" v-else>回复 @{{ textUser | filterUserName }}</div>
          <div class="cancel" @click="calcelDiscuss">取消</div>
        </div>
        <div class="content-box">
          <!-- <textarea
            placeholder="请站在公平、公正的角度来进行评论，诋毁、恶意攻击、无事实依据、非正能量的消极评语会被管理员删除哦。"
            maxlength="500"
            indicator="true"
            class="discuss-content"
            v-model="discussContent"
          >
          </textarea>
          <div class="font-num">{{ 500 - discussContent.length }}</div> -->
          <van-field
            v-model="discussContent"
            rows="3"
            :autosize="{ maxHeight: 200 }"
            :border="true"
            type="textarea"
            maxlength="150"
            placeholder="请站在公平、公正的角度来进行评论，诋毁、恶意攻击、无事实依据、非正能量的消极评语会被管理员删除哦。"
            show-word-limit
          />
        </div>
        <div class="bottom">
          <div
            class="submit"
            :class="{ active: discussContent }"
            @click="toSubmit"
          >
            发表
          </div>
        </div>
      </div>
    </div>
    <!-- 评论上线后放开  end-->
  </cube-sticky>
</template>

<script>
import {
  getNewsDetails,
  getDiscussList,
  addDiscuss,
  deleteDiscuss,
  addReply,
  deleteReply,
} from "@/api/api";
import baseUrl from "@/api/uploadurl";
export default {
  filters: {
    // 过滤留言和回复的用户名
    filterUserName(userName) {
      if (!userName) return "--";
      let len = userName.length;
      let firstName = userName.slice(0, 1);
      let star = "";
      for (let i = 0; i < len - 1; i++) {
        star += "*";
      }
      return firstName + star;
    },
  },
  computed: {
    imgBase() {
      return `${baseUrl.imgBaseUrl}/image/`;
    },
    calcReplyList() {
      return function(flag, list) {
        if (flag) {
          return list;
        } else {
          return list.slice(0, 3);
        }
      };
    },
  },
  data() {
    return {
      isLogined: false,
      newsId: "",
      newsDatails: {},
      imgbaseurl: baseUrl.imgBaseUrl,
      lcsmyos: true,
      nodata: false,
      showData: false,
      scrollY: 0,
      checkTop: true,
      showDiscuss: false,
      discussContent: "",
      discussCount: 0,
      discussList: [],
      textUser: "",
      discussType: "",
      imgs: [],
      replyInfo: {},
      seeMoreIndex: -1,
    };
  },
  deactivated() {
    document.title = "";
  },
  methods: {
    // 获取浏览器UA
    getAPPUA: function() {
      var u = navigator.userAgent;
      if (u.indexOf("lcsmy") != -1) {
        // 在APP内打开，不用提示下载
        this.lcsmyos = true;
      } else {
        this.lcsmyos = false;
      }
    },
    // 点击下载
    toDownapp: function() {
      var host_url = window.location.hostname;
      if (host_url == "localhost") {
        host_url = "wonders.yun.liuzhou.gov.cn";
      }
      window.location.href = "https://" + host_url;
    },
    scrollHandler(e) {
      this.scrollY = e.currentTarget.scrollTop;
      this.$refs.sticky.refresh();
    },
    // 预览解析的图片  $event.target.currentSrc为base64的图片地址
    previewImg($event) {
      console.log($event.target.nodeName);
      console.log($event.target.currentSrc);
      if ($event.target.nodeName === "IMG") {
        // 获取触发事件对象的属性
        if ($event.target.currentSrc) {
          this.imgs[0] = $event.target.currentSrc;
          if (!this.showimg) {
            this.showimg = this.$createImagePreview(
              {
                imgs: this.imgs,
              },
              h => {
                return h("div", {
                  class: {
                    "image-preview-custom-header": true,
                  },
                  slot: "footer",
                });
              }
            );
          }
          this.showimg.show();
        }
      }
    },
    // 资讯内容
    getNewsDetails() {
      getNewsDetails(this.newsId).then(res => {
        console.log(res);
        if (res.code == 200 && res.data) {
          this.newsDatails = res.data;
          this.showData = true;
          this.nodata = false;
          this.getDiscussList();
        } else {
          this.showData = false;
          this.nodata = true;
        }
      });
    },
    // 打开留言框
    toDiscuss(type, option) {
      // 未登录跳转登录
      let ua = navigator.userAgent;
      if (this.isLogined == false) {
        this.$eshimin.userLogin({
          onResponse: userLoginRes => {
            console.log(11, userLoginRes);

            if (ua.indexOf("iOS") != -1) {
              // ios
              this.$eshimin.reloadUrl();
            } else if (ua.indexOf("Android") != -1) {
              // Android
              window.location.reload();
            }
          },
        });

        return false;
      }

      this.showDiscuss = true;
      // 留言
      if (type == 1) {
        this.discussType = 1;
        this.textUser = option.textUser;
      }
      // 回复
      if (type == 2) {
        this.discussType = 2;
        this.textUser = option.userName;
        this.replyInfo = option;
      }
    },
    // 取消留言
    calcelDiscuss() {
      this.discussContent = "";
      this.showDiscuss = false;
    },
    // 提交留言||提交回复
    toSubmit() {
      if (!this.discussContent) return false;
      // 留言
      if (this.discussType == 1) {
        let params = {
          articleId: this.newsId,
          content: this.discussContent,
        };
        console.log("addDiscuss", params);
        addDiscuss(params).then(res => {
          console.log("addDiscuss", res);
          if (res.code == 200) {
            // 清除留言&&关闭输入框
            this.submitHandle();
          }
        });
      }
      // 回复
      if (this.discussType == 2) {
        let params = {
          commentId: this.replyInfo.id,
          replyContent: this.discussContent,
        };
        console.log("addReply", params);
        addReply(params).then(res => {
          console.log("addReply", res);
          if (res.code == 200) {
            // 清除回复&&关闭输入框
            this.submitHandle();
          }
        });
      }
    },
    // 提交后处理
    submitHandle() {
      this.discussContent = "";
      this.showDiscuss = false;
      this.$createToast({
        txt: "发表成功，正在审核中...",
        type: "txt",
      }).show();
    },
    // 留言列表
    getDiscussList() {
      getDiscussList({
        articleId: this.newsId,
      }).then(res => {
        // if (res.code == 200) {
        //   this.discussCount = res.total;
        //   this.discussList = res.rows || [];
        // }
        this.discussCount = res.total || 0;
        this.discussList = res.rows || [];
      });
    },
    // 确认框
    confirm(title, successCallback, cancelCallback) {
      this.$createDialog({
        type: "confirm",
        title: title,
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;",
        },
        cancelBtn: {
          text: "取消",
          active: false,
          disabled: false,
          href: "javascript:;",
        },
        onConfirm: successCallback,
        onCancel: cancelCallback,
      }).show();
    },
    // 删除留言
    deleteDiscuss(id, isRemove) {
      // isRemove==1可删除
      if (isRemove == "1") {
        this.confirm(
          "确定删除留言吗",
          () => {
            deleteDiscuss({ id: id }).then(res => {
              if (res.code == 200) {
                this.getDiscussList();
              }
            });
          },
          () => {
            console.log("取消");
          }
        );
      }
    },
    // 删除回复
    deleteReply(id, isRemove) {
      // isRemove==1可删除
      if (isRemove == "1") {
        this.confirm(
          "确定删除回复吗",
          () => {
            deleteReply({ id: id }).then(res => {
              if (res.code == 200) {
                this.getDiscussList();
              }
            });
          },
          () => {
            console.log("取消");
          }
        );
      }
    },
    seeMore(i) {
      this.seeMoreIndex = i;
    },
  },
  created() {
    document.title = "资讯";
    this.getAPPUA();
    // 拿到资讯id
    this.newsId = this.$route.query.newsId;
    let vconsole = this.$route.query.vconsole || "";
    if (vconsole) {
      new this.$vconsole();
    }
    if (this.newsId) {
      this.getNewsDetails();
    }
    // 判断是否登录;
    this.isLogined = window.globalThis.$cookies.get("TGT") ? true : false;
    console.log(222, window.globalThis.$cookies.get("TGT"));
  },
};
</script>
<style lang="less" scoped>
.cube-sticky {
  .scroll-ele {
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .newtitlebox {
      height: 80px;
      display: flex;
      background: #2c7dea;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-image: url(https://lcsmy.yun.liuzhou.gov.cn/image/file/common/xiazaiapp.jpg);
      box-sizing: border-box;
      z-index: 99999;
      .btnbox {
        width: 120px;
        flex: none;
        a {
          display: inline-block;
          margin: 24px 0 0 15px;
          width: 90px;
          height: 32px;
          line-height: 32px;
          background: #fff;
          border-radius: 4px;
          font-size: 16px;
          text-align: center;
          color: #0882f3;
          box-shadow: 0 0 6px #0882f3;
          text-decoration: none;
        }
      }
      .titlebox {
        flex-grow: 1;
        p {
          padding: 10px 15px;
          font-size: 14px;
          color: white;
          line-height: 20px;
        }
      }
    }
    #news-main {
      background: #fff;
      padding: 15px;
      #data-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 23px;
      }
      #data-time {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 17px;
        margin: 8px 0 20px 0;
        .time {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
        .comment-numbox {
          padding: 0 13px;
          display: flex;
          align-items: center;
          border: 1px solid #eaedf0;
          border-radius: 16px;
          background-color: #f4f6f8;
          .icon {
            width: 11px;
            height: 11px;
          }
          .comment-num {
            margin-left: 6px;
            font-size: 12px;
            color: #999999;
          }
        }
      }
      #data-body {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        /deep/ img {
          max-width: 100%;
          height: auto;
        }
        /deep/ p {
          padding: 4px 0 6px 0 !important;
        }
        /deep/ strong {
          font-weight: bold !important;
        }
        /deep/ h1 {
          font-weight: bold !important;
        }
        /deep/ h2 {
          font-weight: bold !important;
        }
        /deep/ h3 {
          font-weight: bold !important;
        }
        /deep/ h4 {
          font-weight: bold !important;
        }
      }
      .data-file {
        margin-top: 20px;
        padding: 12px;
        background: #f9f9f9;
        .filetitle {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
        }
        .filename {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
        }
        .filedown {
          padding-bottom: 20px;
          line-height: 21px;
          .abtn1 {
            margin-right: 10px;
            display: inline-block;
            text-align: center;
            width: 68px;
            height: 21px;
            background: #0882f3;
            border-radius: 1px;
            font-size: 12px;
            font-weight: 400;
            color: #ffffff;
            line-height: 21px;
          }
          .abtn2 {
            margin-right: 10px;
            display: inline-block;
            text-align: center;
            width: 66px;
            height: 19px;
            border: 1px solid #0882f3;
            background: #ffffff;
            border-radius: 1px;
            font-size: 12px;
            font-weight: 400;
            color: #0882f3;
            line-height: 21px;
          }
        }
      }
    }
    .gap {
      height: 10px;
      background-color: #f4f6f8;
    }
  }
  .input-box {
    padding: 0 15px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    .comment-num {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
    .my-input {
      padding: 0 30px 0 16px;
      display: flex;
      align-items: center;
      height: 33px;
      background-color: #f4f6f8;
      border-radius: 16px;
      .writing-icon {
        width: 13px;
        height: 13px;
      }
      .text {
        margin-left: 8px;
        font-size: 14px;
      }
    }
  }
}
.no-comment {
  line-height: 71px;
  text-align: center;
  font-size: 16px;
  color: #000;
  background-color: #fff;
}
.comment-box {
  padding: 15px;
  background-color: #fff;
  .comment-list {
    display: flex;
    .icon {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #f4f6f8;
    }
    .list-right {
      flex: 1;
      margin-left: 12px;
      .author {
        line-height: 20px;
        font-size: 14px;
        color: #666;
      }
      .comment-text {
        margin-top: 9px;
        line-height: 24px;
        font-size: 17px;
        text-align: justify;
        word-break: break-all;
        color: #333;
      }
      .toolbox {
        margin-top: 9px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        font-weight: 18px;
        .tool-left {
          display: flex;
          align-items: center;
          .time {
            color: #999;
          }
          .delete {
            margin-left: 12px;
            color: #333;
          }
        }
        .tool-right {
          color: #333;
        }
      }
      .answer-box {
        margin-top: 9px;
        padding: 10px 12px;
        box-sizing: border-box;
        border-radius: 8px;
        background-color: #f4f6f8;
        overflow: hidden;
        .answer-list {
          .content {
            font-size: 15px;
            line-height: 21px;
            text-align: justify;
            .answer-name {
              color: #666;
            }
            .answer-content {
              word-break: break-all;
              color: #333;
            }
          }
          .answer-tool {
            margin-top: 5px;
            display: flex;
            align-items: center;
            font-size: 13px;
            line-height: 18px;
            .time {
              color: #999;
            }
            .delete {
              margin-left: 12px;
              color: #333;
            }
          }
        }
        .answer-list ~ .answer-list {
          margin-top: 9px;
        }
        .see-more {
          margin-top: 15px;
          display: flex;
          align-items: center;
          span {
            font-size: 15px;
            line-height: 21px;
            color: #1890ff;
          }
          .arrow {
            margin-left: 5px;
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
  .comment-list ~ .comment-list {
    margin-top: 25px;
  }
}
.discuss {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
  border-top: 1px solid #ebeced;
  background-color: #fff;
  overflow: hidden;
  .top-box {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    .title {
      color: #666666;
    }
    .cancel {
      color: #2288ff;
    }
  }
  .content-box {
    // position: relative;
    // .discuss-content {
    //   padding: 9px 12px 20px;
    //   width: 100%;
    //   min-height: 110px;
    //   box-sizing: border-box;
    //   background-color: #f4f6f8;
    //   border-radius: 8px;
    //   resize: none;
    //   border: none;
    //   outline: none;
    //   font-size: 16px;
    //   line-height: 23px;
    //   text-align: justify;
    //   &::-webkit-input-placeholder {
    //     color: #999;
    //   }
    //   &:focus {
    //     color: #333;
    //   }
    // }
    /deep/.van-cell.van-field {
      .van-cell__value.van-cell__value--alone.van-field__value {
        .van-field__body {
          textarea {
            padding: 9px 12px 20px;
            width: 100%;
            box-sizing: border-box;
            background-color: #f4f6f8;
            border-radius: 8px;
            text-align: justify;
            font-size: 16px;
            outline: none;
            border: none;
            &::-webkit-input-placeholder {
              color: #999;
            }
            &:focus {
              color: #333;
            }
          }
        }
        .van-field__word-limit {
          text-align: right;
          font-size: 12px;
          color: #999;
        }
      }
    }
    // .font-num {
    //   position: absolute;
    //   right: 12px;
    //   bottom: 9px;
    //   text-align: right;
    //   font-size: 12px;
    //   color: #999;
    // }
  }
  .bottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 52px;
    .submit {
      width: 62px;
      line-height: 30px;
      border-radius: 5px;
      background-color: #cccccc;
      text-align: center;
      font-size: 16px;
      color: #fff;
      &.active {
        background-color: #2288ff;
      }
    }
  }
}
</style>
